module.exports = __webpack_public_path__ + "img/login-l.00f3d61f.png";